import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Colors, formatType, Images, token } from 'utils';
import { MinLoader } from 'components';

const reportStatusEnum = {
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    NO_DATA: 'NO_DATA',
};

export function ReportPopup({ reportSession }) {
    // const baseUrl = localStorage.getItem('baseUrl');
    const [load, setLoadDownload] = useState(false);
    const [messages, setMessages] = useState([]);

    useEffect(() => {
        if (reportSession) {
            setMessages((prev) => [...prev, reportSession]);
        }
    }, [reportSession]);

    // useEffect(() => {
    //     const eventSource = new EventSource(`${baseUrl}/reports/events/${token}`);
    //     eventSource.onmessage = (event) => {
    //         try {
    //             const data = JSON.parse(event.data);
    //             if (data.type === 'ping') return;
    //             setMessages((prev) => [...prev, data]);
    //         } catch (err) {
    //             console.error('Error parsing SSE message', err);
    //         }
    //     };
    //     eventSource.onerror = (err) => {
    //         eventSource.close();
    //     };
    //     return () => {
    //         eventSource.close();
    //     };
    // }, []);

    const handleDownload = async (item) => {
        setLoadDownload(item?.reportId);
        try {
            const response = await axios({
                url: `/reports/download/${item?.reportId}`,
                method: 'POST',
                // responseType: 'blob',
                headers: { 'access-token': `${token()}` },
            });
            setLoadDownload(null);
            // const url = window.URL.createObjectURL(new Blob([response.data]));
            const url = response.data;
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', item?.reportName);
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            setMessages((prevMessages) => prevMessages.filter((msg) => msg.reportId !== item.reportId));
        } catch (e) {
            setLoadDownload(null);
        }
    };

    return (
        <div className="report-popup-wrapper">
            {!!messages?.length &&
                messages?.map((i, j) => (
                    <div key={j} className="report-toaster-box">
                        <img
                            src={
                                i?.status === reportStatusEnum?.SUCCESS
                                    ? Images.successIcon
                                    : i?.status === reportStatusEnum?.NO_DATA
                                      ? Images.infoIcon
                                      : Images.errorIcon
                            }
                            alt="success"
                            className="toast-icon"
                        />
                        <div className="full-width">
                            <p className="report-toast-message">
                                {i?.status === reportStatusEnum?.SUCCESS
                                    ? `New ${formatType(i?.type)} generated`
                                    : i?.status === reportStatusEnum?.NO_DATA
                                      ? `No data found for ${formatType(i?.type)} with the selected filters`
                                      : `Failed to generate ${formatType(i?.type)}`}
                            </p>

                            {i?.status === reportStatusEnum?.SUCCESS && (
                                <div className="flex-align-start" style={{ gap: 12 }}>
                                    <p className="report-name">{i?.reportName}</p>

                                    <button onClick={() => handleDownload(i)} className="download-report-btn">
                                        {load === i?.reportId ? (
                                            <MinLoader
                                                margin={'0'}
                                                width={'18px'}
                                                height={'18px'}
                                                color={Colors.ThemeBlue}
                                                position={'relative'}
                                            />
                                        ) : (
                                            <img src={Images.downloadCloudBlue} alt="download" />
                                        )}
                                        <p>Download</p>
                                    </button>
                                </div>
                            )}
                        </div>
                        <button
                            className="close-toaster-btn"
                            onClick={() => {
                                setMessages((prevMessages) => prevMessages.filter((msg) => msg.reportId !== i.reportId));
                            }}
                        >
                            <img src={Images.closeSingleVector} alt="close" />
                        </button>
                    </div>
                ))}
        </div>
    );
}
